import React, { Component } from "react"
import {
	Modal,
	Grid,
	Row,
	Col,
	Panel,
	Well,
	Alert,
	ProgressBar,
} from "react-bootstrap"
import request from "./request"
import marked from "marked"
import * as firebase from "firebase"
import { signOut } from "./user"

export default class PlanExpiredModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isPurchasing: false,
			errorMessage: null,
		}
	}

	render() {
		const { errorMessage } = this.state
		const { planExpiresAt, upgradeMessage = null } = this.props
		const expiredAtString = planExpiresAt.toLocaleDateString("en-US", {
			weekday: "long",
			month: "long",
			day: "numeric",
		})
		return (
			<div>
				<Modal.Header>
					<Modal.Title>
						Your free 10-day trial ended on {expiredAtString}.
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="plan-expired-body">
						{errorMessage !== null ? (
							<Alert bsSize="danger">{errorMessage}</Alert>
						) : null}
						{upgradeMessage !== null ? (
							<Alert bsSize="info">
								<div
									className="message-content"
									dangerouslySetInnerHTML={{
										__html: marked(upgradeMessage.message, { sanitize: true }),
									}}
								/>
								{upgradeMessage.progress ? (
									<ProgressBar className="payment-progress" active now={100} />
								) : null}
							</Alert>
						) : null}
						<h2 className="plan-expired-heading">
							Thank you for trying out Crypto Portfolio Tracker!
						</h2>
						<p>
							Your free trial has expired, but you can keep using Crypto
							Portfolio Tracker with a paid plan.
						</p>
						<p className="plan-expired-p">
							<b>The easiest to use portfolio tracker.</b>
							<br />
							Hundreds of traders use Crypto Portfolio Tracker to get an edge in
							the fast-moving crypto world. Don't get left behind!
						</p>
						<p className="plan-expired-p2">
							<b>Choose a plan to keep using Crypto Portfolio Tracker.</b>
						</p>
						<Grid fluid>
							<Row>
								<Col sm={1} md={1} />
								<Col sm={5} md={5}>
									<Panel>
										<div className="front-plan">
											<p className="plans-title">Standard</p>
											<p className="plans-price">$29.95</p>
											<p className="plans-price-detail">1 year</p>
											<p>For crypto traders and holders</p>
											<p>
												Track <b>unlimited trades</b> on up to{" "}
												<b>4 exchanges</b>
											</p>
											{this.buyButton("Standard", "standard", 29.95)}
										</div>
									</Panel>
								</Col>
								<Col sm={5} md={5}>
									<Panel>
										<div className="front-plan">
											<p className="plans-title">Pro</p>
											<p className="plans-price">$39.95</p>
											<p className="plans-price-detail">1 year</p>
											<p>For advanced traders</p>
											<p>
												Track <b>unlimited trades</b> on up to{" "}
												<b>6 exchanges</b>
											</p>
											{this.buyButton("Pro", "pro", 39.95)}
										</div>
									</Panel>
								</Col>
								<Col sm={1} md={1} />
							</Row>
						</Grid>
						<Well className="plan-expired-info-section">
							<p>
								<b>Did Crypto Portfolio Tracker not work for you?</b>
								<br />
								We'd love to hear why. We're always looking for ways to get
								better. If you have feedback you think would be useful, please
								send us a{" "}
								<a className="cursor-pointer" onClick={this.openChatHandler}>
									chat message
								</a>.
							</p>
							<p className="plan-expired-no-bottom-margin">
								<b>Prefer to delete your account instead?</b>
								<br />
								We'll be sorry to see you go. Once your account is deleted, your
								exchange accounts and portfolio will be immediately and
								permanently destroyed. To delete your account,{" "}
								<a
									className="cursor-pointer"
									onClick={this.deleteAccountHandler}
								>
									click here
								</a>.
							</p>
						</Well>
					</div>
				</Modal.Body>
			</div>
		)
	}

	openChatHandler = () => {
		window.$crisp.push([
			"do",
			"message:show",
			[
				"text",
				"Will you let us know why Crypto Portfolio Tracker didn't work for you? It'll just take a minute.",
			],
		])
		window.$crisp.push(["do", "chat:open"])
	}

	deleteAccountHandler = async () => {
		const { uid } = this.props
		const db = firebase.firestore()
		const batch = db.batch()
		batch.delete(db.collection("accounts").doc(uid))
		batch.delete(db.collection("secrets").doc(uid))
		batch.delete(db.collection("portfolios").doc(uid))
		await batch.commit()
		window.alert(
			"Your account has been permanently deleted. Thank you for trying out Crypto Portfolio Tracker."
		)
		await signOut()
	}

	buyButton(name, plan, price) {
		const { uid } = this.props
		const user = firebase.auth().currentUser

		if (user === null) {
			throw new Error("No user!")
		}

		return (
			<form action="https://www.coinpayments.net/index.php" method="post">
				<input type="hidden" name="cmd" value="_pay_simple" />
				<input type="hidden" name="reset" value="1" />
				<input
					type="hidden"
					name="merchant"
					value={process.env.REACT_APP_COINPAYMENTS_MERCHANT_ID}
				/>
				<input type="hidden" name="currency" value="USD" />
				<input type="hidden" name="amountf" value={price} />
				<input
					type="hidden"
					name="item_name"
					value={`Crypto Portfolio Tracker - ${name} (1 Year) `}
				/>
				<input type="hidden" name="item_number" value={plan} />
				<input type="hidden" name="first_name" value={user.displayName} />
				<input type="hidden" name="email" value={user.email} />
				<input type="hidden" name="custom" value={uid} />
				<input
					type="hidden"
					name="ipn_url"
					value={process.env.REACT_APP_COINPAYMENTS_IPN_URL || ""}
				/>
				<input type="hidden" name="success_url" value={window.location.href} />
				<input type="hidden" name="cancel_url" value={window.location.href} />
				<input
					type="image"
					src="https://www.coinpayments.net/images/pub/buynow-wide-yellow.png"
					alt="Buy Now with CoinPayments.net"
					className="payment-button"
				/>
			</form>
		)
	}

	purchaseHandler(plan) {
		const { uid } = this.props
		return async () => {
			if (this.state.isPurchasing) {
				return
			}
			this.setState({
				isPurchasing: true,
				errorMessage: null,
			})
			try {
				const result = await request(uid, {
					action: "createInvoice",
					payload: {
						plan,
					},
				})
				window.location.replace(result.url)
			} catch (error) {
				this.setState({
					errorMessage: error.message,
				})
				throw error
			} finally {
				this.setState({
					isPurchasing: false,
				})
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/PlanExpiredModal.js